var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Notification',{attrs:{"value":_vm.visibility,"color":_vm.type}},[_vm._v(_vm._s(_vm.message))]),_vm._t("content",[_vm._v("コンテンツ")]),_c('SettingMenuNavigation')],2)}
var staticRenderFns = []

export { render, staticRenderFns }